import React from 'react'
import { Card, Button, Row, Col, Tag } from 'antd'
import { PlusOutlined, VideoCameraOutlined } from '@ant-design/icons'
import './ConsultationManagement.css'

const ConsultationManagement: React.FC = () => {
  const consultations = [
    {
      id: 1,
      patient: '张三',
      topic: '疑难病例会诊',
      doctors: ['李医生', '王医生'],
      time: '2024-01-20 14:00',
      status: 'scheduled',
    },
  ]

  return (
    <div className="consultation-management-page">
      <div className="page-header">
        <h1 className="page-title">会诊管理</h1>
        <Button type="primary" icon={<PlusOutlined />}>
          新建会诊
        </Button>
      </div>

      <div className="consultation-grid">
        <Row gutter={[24, 24]}>
          {consultations.map((consultation) => (
            <Col xs={24} sm={12} lg={8} key={consultation.id}>
              <Card
                className="consultation-card card-hover"
                actions={[
                  <Button type="link" icon={<VideoCameraOutlined />}>
                    进入会诊
                  </Button>,
                ]}
              >
                <div className="consultation-info">
                  <h3>{consultation.topic}</h3>
                  <p>患者：{consultation.patient}</p>
                  <p>时间：{consultation.time}</p>
                  <div className="doctors-list">
                    {consultation.doctors.map((doctor, index) => (
                      <Tag key={index}>{doctor}</Tag>
                    ))}
                  </div>
                  <Tag color="processing">{consultation.status}</Tag>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}

export default ConsultationManagement

